import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";

const RoutesWrapper = (props) => {
    return (
        <BrowserRouter>
            <Routes {...props} />
        </BrowserRouter>
    );
};

export default RoutesWrapper;